// extracted by mini-css-extract-plugin
module.exports = {"title":"Success_title___gN1Y"};